import angular from 'angular';
import { slugifyModule } from '../../../widget/services/filters/slugify/slugify.module';
import { bitUrlBuilderFactory } from './bitUrlBuilder.factory';

export const bitUrlBuilderModule = angular
  .module('bit.services.bitUrlBuilder', [slugifyModule.name])
  .factory('bitUrlBuilder', bitUrlBuilderFactory);
